module.exports = __webpack_public_path__ + "static/calatonSystemsBrandingDesktop@2x-407afd5c73a1a14ea67b018a9a1f9b77.jpg";